import { messageHasTags } from "@/lib/messageBody";
import "./MessageHtml.css";

export default function MessageHtml({ body, className }: { body: string; className?: string }) {
  if (messageHasTags(body)) {
    return <div className={`al-msg-html${className ? ` ${className}` : ""}`} dangerouslySetInnerHTML={{ __html: body }} />;
  }
  return <p className={`al-msg-plain${className ? ` ${className}` : ""}`}>{body}</p>;
}
